// Matches valid SQL year types
export const yearRegex = /^(([0-9]{2})|(190[1-9])|(19[1-9][0-9])|(20[0-9]{2})|(21[0-4][0-9])|(215[0-5]))$/;